var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8BDB83F8-B6B0-4465-A3B6-736EB271397B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sales-Package",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sales->-Sub->-Lead-Listing->-Custom-Views-Manager",
    transform: "translate(-384.000000, -280.000000)",
    fill: "#0CAC45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.5,280 C388.950467,280 389.437654,280.529066 389.777973,281.845748 C389.845866,282.108422 389.711132,282.467957 389.437654,282.50622 C389.164175,282.544484 388.857404,282.308975 388.812219,282.037449 C388.671393,281.191196 388.408723,281 387.5,281 C386.448859,281 386.087628,281.504212 386.014754,283.4999 L390,283.5 C390.552285,283.5 391,283.947715 391,284.5 L391,288.5 C391,289.052285 390.552285,289.5 390,289.5 L385,289.5 C384.447715,289.5 384,289.052285 384,288.5 L384,284.5 C384,283.987164 384.38604,283.564493 384.883379,283.506728 L385.017552,283.499185 C385.123847,280.942683 385.736851,280 387.5,280 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e38dde490db0fabac4049dce128db159.svg";
export { ForwardRef as ReactComponent };